module.exports = __webpack_public_path__ + "img/spotify.2d87ef74.png";